import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Success = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    let attempts = 0;
    const maxAttempts = 5;

    const poll = async () => {
      if (attempts >= maxAttempts) {
        setStatus('timeout');
        return;
      }

      try {
        const response = await axios.get(`${BACKEND_URL}/api/payments/status/${sessionId}`);
        if (response.data.payment_status === 'paid') {
          setStatus('success');
        } else if (response.data.status === 'expired') {
          setStatus('failed');
        } else {
          attempts++;
          setTimeout(poll, 2000);
        }
      } catch (error) {
        setStatus('error');
      }
    };

    poll();
  };

  return (
    <div className="min-h-screen bg-zinc-900 flex items-center justify-center py-24">
      <div className="max-w-md w-full text-center">
        {status === 'checking' && (
          <div data-testid="payment-checking">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-pink-600 mx-auto mb-6"></div>
            <h2 className="text-2xl font-bold mb-2">Verificando pago...</h2>
            <p className="text-zinc-400">Por favor espera un momento</p>
          </div>
        )}
        {status === 'success' && (
          <div data-testid="payment-success">
            <CheckCircle2 className="w-24 h-24 text-green-500 mx-auto mb-6" />
            <h2 className="text-4xl font-bold mb-4" style={{fontFamily: 'Syne, sans-serif'}}>¡Pago Exitoso!</h2>
            <p className="text-zinc-400 mb-8">Tu suscripción ha sido activada. Ya puedes acceder a todo el contenido.</p>
            <Button onClick={() => navigate('/dashboard')} className="bg-pink-600 hover:bg-pink-700 text-white rounded-full px-12 py-6 font-bold">
              Ir al Dashboard
            </Button>
          </div>
        )}
        {(status === 'failed' || status === 'error' || status === 'timeout') && (
          <div data-testid="payment-failed">
            <h2 className="text-4xl font-bold mb-4" style={{fontFamily: 'Syne, sans-serif'}}>Error en el Pago</h2>
            <p className="text-zinc-400 mb-8">Hubo un problema con tu pago. Por favor inténtalo nuevamente.</p>
            <Button onClick={() => navigate('/programs')} className="bg-pink-600 hover:bg-pink-700 text-white rounded-full px-12 py-6 font-bold">
              Volver a Intentar
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Success;